exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#kpi_Sheet {\n  height: calc(100% - 0%) !important;\n  overflow: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/kpi/kpi-sheet-view/kpi-sheet-view.component.scss
// module id = ../../../../../src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/kpi/kpi-sheet-view/kpi-sheet-view.component.scss
// module chunks = main